import * as React from 'react';
import ServiceUser from "./ServiceUser";
import {CustomNotifMessage} from "../common";
import LoadingCustom from "../common/LoadingCustom";
import ServiceDeleteLocalStorage from "./ServiceDeleteLocalStorage";
import Redirect from "react-router-dom/es/Redirect";
import ServiceFailErreur from "./ServiceFailErreur";

export default class ServiceLogout extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      logout: false,
      tokenInvalid:false,
      erreur: null,
      resp: {
        message: "",
        error: "",
        data: null
      },
    };
  }

  componentDidMount() {
    this.getLogout();
  }


  async getLogout() {
    if (this.state.loading === false) {
      ServiceUser.logout().then(response => {
        if (response.data.code === 0) {
          this.setState({
            logout: ServiceDeleteLocalStorage.removeItemValue(),
            erreur:null,
            loading: true,
          },()=>console.log(this.state.logout))
        } else {
          this.setState({
            erreur: response.data.message,
            loading: true,
          })
        }
      }, (error) => {
        this.setState({
          error:ServiceFailErreur.getErreur(error),
          tokenInvalid: ServiceFailErreur.invalidTokenRequered(error),
          loading: true
        },()=>{
          if(this.state.tokenInvalid){
            this.setState({
              logout: ServiceDeleteLocalStorage.removeItemValue(),
              erreur:null,
              loading: true,
            })
          }
        })
      });
    }
  }

  logOut() {
    if (this.state.logout) {
      return (<Redirect to='/login'/>);
    }
    return (<div></div>);

  }

  render() {
    return (
      <div>
        <CustomNotifMessage warr={this.state.error} clean={()=>{this.setState({error:''})}}/>
        {this.state.loading ? this.logOut() : ''}
      </div>
    );
  }
}
